






















import { Component, Vue } from 'vue-property-decorator';
import Bar from '@/components/organizationDashboard/charts/Bar.vue';

@Component({
  components: {
    Bar,
  },
})
export default class PerformanceCard extends Vue {
  private organizationAvatarSize: number = 32;
  private organizationAvatarColor: string = '#fdb44d';
}
